import { render, staticRenderFns } from "./propertyOwnerDetail.vue?vue&type=template&id=a2512f34&scoped=true"
import script from "./propertyOwnerDetail.vue?vue&type=script&lang=js"
export * from "./propertyOwnerDetail.vue?vue&type=script&lang=js"
import style0 from "./propertyOwnerDetail.vue?vue&type=style&index=0&id=a2512f34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2512f34",
  null
  
)

export default component.exports